var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.f{fill:#fff;}.b{fill:#a9cbd3;}.c{opacity:0.6;}.d{fill:#98c98d;}.e{fill:#71a665;}.f{mix-blend-mode:soft-light;isolation:isolate;}.g{opacity:0.5;}.h{fill:#9cbdb7;}.i{fill:#7ca0d4;}.j{fill:#dbeafc;}.k{fill:#e86a50;}.l{fill:#fca16a;}.m{fill:#f1a450;}.n{fill:#f48337;}.o{fill:#261126;}.p{fill:#8090df;}.q{fill:#623365;}.r{fill:#2e4a75;}.s{fill:#213478;}.t{fill:#689ded;}.u{fill:#040404;}.v{fill:#e06f4a;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M300.6,212.192c-23.068,1.165-45.743,10.728-91.092,29.854-53.321,22.487-80.2,34.083-91.093,51.287-27.22,43.008-3.146,99.936,1.531,110.995,4.8,11.339,20.674,47.476,58.942,68.893,34.519,19.319,68.841,16.353,116.353,12.248a345.385,345.385,0,0,0,65.832-12.248c33.851-9.756,64.846-18.689,88.8-45.929,7.372-8.386,29.283-33.308,22.2-54.35-6.017-17.87-26.867-14.876-35.977-35.212-8.928-19.928,6.689-32.636,0-56.645-5.069-18.191-18.967-28.6-32.916-39.039C360.755,210.285,311.734,211.629,300.6,212.192Z",
  transform: "translate(-98.3 -212)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(16.89 201.985)"
}, /*#__PURE__*/React.createElement("ellipse", {
  className: "b",
  cx: 160.448,
  cy: 20.996,
  rx: 160.448,
  ry: 20.996,
  transform: "translate(0 0)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(206.113 16.322)"
}, /*#__PURE__*/React.createElement("g", {
  className: "c",
  transform: "translate(0 2.753)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M415.347,401.364s71.4-156.979,113.271-136S457.465,359.949,438.126,406.3Z",
  transform: "translate(-415.347 -263.432)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(23.813 73.034)"
}, /*#__PURE__*/React.createElement("path", {
  className: "e",
  d: "M447.9,424.127s97.479-88.144,126.147-58.545-81.55,43.361-108.918,70Z",
  transform: "translate(-447.899 -359.505)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(8.833 15.608)"
}, /*#__PURE__*/React.createElement("path", {
  className: "f",
  d: "M460.722,436.345c18.567-18.738,45.026-32.555,63.952-40.846a316.124,316.124,0,0,1,37-13.643l-.284-1.015a317.214,317.214,0,0,0-37.143,13.692c-19.01,8.328-45.593,22.214-64.277,41.07Z",
  transform: "translate(-459.974 -380.841)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(13.396 120.066)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M538.295,471.458c-14.35,3.274-11.718,25.022-28.156,21.165-13.9-3.271-15.083-4.536-19.838-.489a22.635,22.635,0,0,0-4.208,4.808c-1.412,2.142-4.149,5.305-8.351,6.091-25.674,4.8-61.269-32.851-34.665-54.113,1.921-1.536,4.735-2.15,7.853-2.674,16.912-2.832,22.277,4.886,35.4-15.228s31.56,8.31,42.911,7.176,21.324-4.653,30.31,7.288S552.647,468.195,538.295,471.458Z",
  transform: "translate(-433.659 -423.798)"
}), /*#__PURE__*/React.createElement("g", {
  className: "g",
  transform: "translate(17.372 2.147)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 22.934)"
}, /*#__PURE__*/React.createElement("path", {
  className: "f",
  d: "M457.955,485.711l-.549-.8c.351-.242,36.016-24.262,110.6-26.83l.034.968C493.736,461.61,458.305,485.47,457.955,485.711Z",
  transform: "translate(-457.406 -458.084)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(34.827 4.955)"
}, /*#__PURE__*/React.createElement("path", {
  className: "f",
  d: "M516.834,449.792c-9.937-8.748-11.747-15.759-11.819-16.053l.94-.231c.017.07,1.835,7.034,11.519,15.557Z",
  transform: "translate(-505.015 -433.508)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(46.48)"
}, /*#__PURE__*/React.createElement("path", {
  className: "f",
  d: "M522.93,458.4c-2.819-4.842-2.634-11.866.533-20.313a64.754,64.754,0,0,1,5.646-11.351l.81.531c-.127.194-12.631,19.514-6.151,30.647Z",
  transform: "translate(-520.944 -426.734)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(66.23 27.454)"
}, /*#__PURE__*/React.createElement("path", {
  className: "f",
  d: "M549.793,466.573c-1.181-.967-1.822-1.6-1.851-1.626l.685-.684c.134.134,13.626,13.387,33.315,12.576l.039.967C566.117,478.459,554.2,470.177,549.793,466.573Z",
  transform: "translate(-547.942 -464.263)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(71.699 32.639)"
}, /*#__PURE__*/React.createElement("path", {
  className: "f",
  d: "M561.722,490.755a22.835,22.835,0,0,1-6.208-13.279,16.9,16.9,0,0,1,.41-6.124l.925.286c-.029.092-2.744,9.372,5.587,18.463Z",
  transform: "translate(-555.418 -471.352)"
})))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(62.578 0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "h",
  d: "M505.288,262.959c2.555-3.539,4.439-3.78,5.826-2.778s1.751,2.866-.8,6.4c-4.655,6.446-9.416,7.748-9.416,7.748S500.565,269.5,505.288,262.959Z",
  transform: "translate(-500.89 -259.668)"
})), /*#__PURE__*/React.createElement("g", {
  className: "c",
  transform: "translate(134.924 124.959)"
}, /*#__PURE__*/React.createElement("path", {
  className: "h",
  d: "M612.694,432.213c4.357,1.6,5.146,3.456,4.52,5.163s-2.429,2.617-6.786,1.02c-7.936-2.909-10.639-7.406-10.639-7.406S604.642,429.262,612.694,432.213Z",
  transform: "translate(-599.788 -430.487)"
})), /*#__PURE__*/React.createElement("g", {
  className: "c",
  transform: "translate(130.259 112.517)"
}, /*#__PURE__*/React.createElement("path", {
  className: "h",
  d: "M602.685,414.631c3.931-1.9,5.7-1.213,6.446.328s.177,3.354-3.754,5.252c-7.16,3.456-11.968,2.336-11.968,2.336S595.42,418.137,602.685,414.631Z",
  transform: "translate(-593.41 -413.478)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(19.744 15.213)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(41.144 10.263)"
}, /*#__PURE__*/React.createElement("path", {
  className: "h",
  d: "M222.821,282.995c-1.566,3.59-3.173,4.161-4.581,3.546s-2.082-2.179-.515-5.77c2.854-6.541,6.781-8.59,6.781-8.59S225.717,276.359,222.821,282.995Z",
  transform: "translate(-216.825 -272.181)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(56.332 30.932)"
}, /*#__PURE__*/React.createElement("path", {
  className: "h",
  d: "M243.182,311.213c-.32,3.9-1.656,4.964-3.187,4.838s-2.675-1.389-2.355-5.293c.584-7.112,3.637-10.322,3.637-10.322S243.775,304,243.182,311.213Z",
  transform: "translate(-237.587 -300.436)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(17.318 43.265)"
}, /*#__PURE__*/React.createElement("path", {
  className: "h",
  d: "M266.443,370.1l-.636.383c-.059-.1-6.048-9.922-19.041-21.246-11.991-10.447-32.568-24.343-62.511-31.214l.166-.723c30.108,6.909,50.8,20.89,62.856,31.4C260.35,360.092,266.383,370,266.443,370.1Z",
  transform: "translate(-184.255 -317.295)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(24.928 10.508)"
}, /*#__PURE__*/React.createElement("path", {
  className: "h",
  d: "M220.483,317.247l-.74.044c-1.585-26.879-24.849-44-25.084-44.173l.435-.6C195.33,272.688,218.877,290.011,220.483,317.247Z",
  transform: "translate(-194.658 -272.516)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(21.631 49.255)"
}, /*#__PURE__*/React.createElement("path", {
  className: "h",
  d: "M203.168,328.3a26.245,26.245,0,0,1-12.991,4.726l-.026-.74c.087,0,8.822-.392,15.168-6.8l.527.521A21.764,21.764,0,0,1,203.168,328.3Z",
  transform: "translate(-190.151 -325.484)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 40.67)"
}, /*#__PURE__*/React.createElement("path", {
  className: "h",
  d: "M175.068,314.013c5.254.556,6.685,1.959,6.524,3.486s-1.855,2.6-7.109,2.043c-9.57-1.012-13.9-4.266-13.9-4.266S165.359,312.985,175.068,314.013Z",
  transform: "translate(-160.581 -313.747)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(8.424 53.235)"
}, /*#__PURE__*/React.createElement("path", {
  className: "h",
  d: "M185.529,331.38c5.177-1.054,6.965-.148,7.271,1.356s-.985,3.038-6.162,4.092c-9.43,1.92-14.542.123-14.542.123S175.962,333.327,185.529,331.38Z",
  transform: "translate(-172.097 -330.923)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(24.01 33.247)"
}, /*#__PURE__*/React.createElement("path", {
  className: "h",
  d: "M203.231,308.414c2.966,2.56,3.034,4.263,2.031,5.426s-2.7,1.343-5.664-1.217c-5.4-4.664-6.195-9.021-6.195-9.021S197.751,303.682,203.231,308.414Z",
  transform: "translate(-193.403 -303.601)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(12.203)"
}, /*#__PURE__*/React.createElement("path", {
  className: "h",
  d: "M189.921,265.311c4.016,3.432,4.4,5.4,3.4,6.566s-3,1.093-7.017-2.339c-7.316-6.252-9.046-11.387-9.046-11.387S182.5,258.969,189.921,265.311Z",
  transform: "translate(-177.263 -258.152)"
})))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(47.521 77.877)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M296.377,419.007s-69.171-92.138-93.467-72.429,60.03,51.471,79.316,78.93Z",
  transform: "translate(-198.552 -343.814)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(8.008 91.707)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M260.35,417.685s-87.122-75.839-111.823-49.353,72.381,36.75,96.872,59.7Z",
  transform: "translate(-144.538 -362.719)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(17.883 13.725)"
}, /*#__PURE__*/React.createElement("path", {
  className: "f",
  d: "M258.6,428.585c-16.626-16.158-40.106-27.861-56.875-34.833a277.77,277.77,0,0,0-32.743-11.375l.233-.9A278.855,278.855,0,0,1,202.082,392.9c16.843,7,40.434,18.764,57.165,35.024Z",
  transform: "translate(-168.983 -381.48)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.291 131.777)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "e",
  d: "M269.667,495.222c-10.439,1.76-22.4,4.168-34.718,6.808a6.36,6.36,0,0,1-6.738-2.851l-.028-.046c-10.234-7.224-8.5-6.188-27.114.86-13.358,5.049-17.27-6.816-24.795-14.522-.136-.141-.275-.28-.415-.418a17.527,17.527,0,0,0-10.955-5.466,57.455,57.455,0,0,1-14.792-3.392q-.582-.218-1.156-.455c-9.325-3.814-16.322-10.161-14.745-18.388.036-.195.078-.391.125-.586a16.511,16.511,0,0,1,1.726-4.271c8.668-15.339,20.867-12.761,34.308-13.181,7.431-.233,16-11.359,25.3-17.631.132-.09.267-.179.4-.267,7.4-4.869,15.255-6.532,23.353,2.906l0,0c.165.192.329.381.491.568,18.033,20.748,23.2,11.083,43.228,11.784,3.724.133,7.109.418,9.591,1.919C295.875,452.576,287.193,479.581,269.667,495.222Z",
  transform: "translate(-133.989 -417.494)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.167 3.878)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 33.513)"
}, /*#__PURE__*/React.createElement("path", {
  className: "f",
  d: "M267.1,485.87l.519-1.016c-.448-.229-45.83-22.819-133.4-14.348l.11,1.137C221.568,463.2,266.652,485.643,267.1,485.87Z",
  transform: "translate(-134.217 -468.607)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(73.629 2.888)"
}, /*#__PURE__*/React.createElement("path", {
  className: "f",
  d: "M235.728,447.45c10.27-11.753,11.307-20.226,11.345-20.581l-1.134-.126c-.01.084-1.064,8.5-11.072,19.956Z",
  transform: "translate(-234.868 -426.743)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(61.009)"
}, /*#__PURE__*/React.createElement("path", {
  className: "f",
  d: "M230.574,458.855c2.549-6.093,1.253-14.274-3.747-23.661a76.294,76.294,0,0,0-8.346-12.4l-.865.745c.178.207,17.766,20.866,11.9,34.876Z",
  transform: "translate(-217.616 -422.795)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(14.749 33.977)"
}, /*#__PURE__*/React.createElement("path", {
  className: "f",
  d: "M190.377,472.121c1.233-1.312,1.884-2.147,1.913-2.186l-.9-.694c-.136.177-13.868,17.743-37.006,19.825l.1,1.136C173.125,488.525,185.784,477.01,190.377,472.121Z",
  transform: "translate(-154.379 -469.241)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(41.642 40.852)"
}, /*#__PURE__*/React.createElement("path", {
  className: "f",
  d: "M192.077,502.211a26.923,26.923,0,0,0,5.214-16.477,19.935,19.935,0,0,0-1.421-7.094l-1.038.476c.048.1,4.649,10.533-3.69,22.44Z",
  transform: "translate(-191.142 -478.64)"
})))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 139.552)"
}, /*#__PURE__*/React.createElement("path", {
  className: "h",
  d: "M138.059,433.882c-3.846-.822-4.729-2.289-4.407-3.8s1.728-2.486,5.575-1.663c7.007,1.5,9.81,4.952,9.81,4.952S145.168,435.4,138.059,433.882Z",
  transform: "translate(-133.591 -428.123)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(97.581 24.166)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 2.871)"
}, /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M408.761,467.937l-128.1,2.252a9.989,9.989,0,0,1-10.162-9.782l-3.51-170.628a9.99,9.99,0,0,1,9.6-10.187l137.507-5.27a9.989,9.989,0,0,1,10.366,10.32l-5.9,173.646A9.988,9.988,0,0,1,408.761,467.937Z",
  transform: "translate(-266.984 -274.315)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(8.96 11.448)"
}, /*#__PURE__*/React.createElement("path", {
  className: "j",
  d: "M406.451,462.649,289.645,464.7a9.109,9.109,0,0,1-9.266-8.92l-1.147-160.707a4.028,4.028,0,0,1,3.874-4.055l129.805-4.975a7.624,7.624,0,0,1,7.912,7.877l-5.43,159.928A9.108,9.108,0,0,1,406.451,462.649Z",
  transform: "translate(-279.232 -286.04)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(42.929 0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "k",
  d: "M329.633,290.676l59.445-1.895a4.842,4.842,0,0,0,4.661-5.342l-.471-4.508a9.529,9.529,0,0,0-9.72-8.536L336.11,271.6a10.055,10.055,0,0,0-9.733,8.894l-.684,5.9A3.843,3.843,0,0,0,329.633,290.676Z",
  transform: "translate(-325.667 -270.391)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(25.317 44.436)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0.876)"
}, /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M327.72,363.637c-.172,0-.344-.006-.517-.018l-19.028-1.31a7.089,7.089,0,0,1-6.582-7.051V339.644a6.614,6.614,0,0,1,6.43-6.639l20.95-.67a6.417,6.417,0,0,1,6.619,6.617l-.557,17.584a7.333,7.333,0,0,1-7.315,7.1Zm-.169-5.075a2.264,2.264,0,0,0,2.418-2.186l.556-17.585a1.348,1.348,0,0,0-1.391-1.39l-20.949.67a1.567,1.567,0,0,0-1.524,1.573v15.613a2,2,0,0,0,1.862,1.994Z",
  transform: "translate(-301.593 -332.332)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(7.665)"
}, /*#__PURE__*/React.createElement("path", {
  className: "k",
  d: "M313.533,340.452a.876.876,0,0,0-1.342,1.088l7.119,12.175c1.315,2.682,4.068,1.638,5.688-.872l13.271-20.565a.7.7,0,0,0-1.011-.971l-12.01,12.666c-5.6,5.4-6.108,2.536-9.3-.845C315.085,342.211,313.533,340.452,313.533,340.452Z",
  transform: "translate(-312.071 -331.135)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(25.317 88.768)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0.875)"
}, /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M327.72,424.239c-.172,0-.344-.007-.517-.018l-19.028-1.31a7.089,7.089,0,0,1-6.582-7.051V400.246a6.614,6.614,0,0,1,6.43-6.639l20.95-.67a6.417,6.417,0,0,1,6.619,6.617l-.557,17.584a7.333,7.333,0,0,1-7.315,7.1Zm-.169-5.075a2.264,2.264,0,0,0,2.418-2.186l.556-17.585a1.348,1.348,0,0,0-1.391-1.39l-20.949.67a1.567,1.567,0,0,0-1.524,1.573v15.613a2,2,0,0,0,1.862,1.994Z",
  transform: "translate(-301.593 -392.933)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(7.665)"
}, /*#__PURE__*/React.createElement("path", {
  className: "k",
  d: "M313.533,401.054a.876.876,0,0,0-1.342,1.088l7.119,12.175c1.315,2.682,4.068,1.638,5.688-.872l13.271-20.565a.7.7,0,0,0-1.011-.971l-12.01,12.666c-5.6,5.4-6.108,2.536-9.3-.845C315.085,402.813,313.533,401.054,313.533,401.054Z",
  transform: "translate(-312.071 -391.737)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(48.041 8.473)"
}, /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M423.86,409.3l-54.317-1.315a2.334,2.334,0,0,1-2.278-2.334h0a2.334,2.334,0,0,1,2.334-2.335h54.152a2.335,2.335,0,0,1,2.317,2.044l.165,1.315A2.334,2.334,0,0,1,423.86,409.3Z",
  transform: "translate(-367.265 -403.319)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(48.041 18.599)"
}, /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M423.86,423.145l-54.317-1.315a2.335,2.335,0,0,1-2.278-2.334h0a2.334,2.334,0,0,1,2.334-2.334h54.152a2.335,2.335,0,0,1,2.317,2.043l.165,1.315A2.335,2.335,0,0,1,423.86,423.145Z",
  transform: "translate(-367.265 -417.161)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(25.317 131.996)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0.876)"
}, /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M327.72,483.331c-.172,0-.344-.007-.517-.018L308.175,482a7.089,7.089,0,0,1-6.582-7.051V459.338a6.614,6.614,0,0,1,6.43-6.639l20.95-.669a6.416,6.416,0,0,1,6.619,6.616l-.557,17.585a7.333,7.333,0,0,1-7.315,7.1Zm-.169-5.075a2.264,2.264,0,0,0,2.418-2.186l.556-17.585a1.349,1.349,0,0,0-1.391-1.39l-20.949.67a1.567,1.567,0,0,0-1.524,1.573v15.613a2.005,2.005,0,0,0,1.862,1.994Z",
  transform: "translate(-301.593 -452.026)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(7.665)"
}, /*#__PURE__*/React.createElement("path", {
  className: "k",
  d: "M313.533,460.146a.876.876,0,0,0-1.342,1.088l7.119,12.175c1.315,2.682,4.068,1.638,5.688-.872l13.271-20.565a.7.7,0,0,0-1.011-.971l-12.01,12.666c-5.6,5.4-6.108,2.536-9.3-.845C315.085,461.905,313.533,460.146,313.533,460.146Z",
  transform: "translate(-312.071 -450.829)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(48.041 8.473)"
}, /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M423.86,468.395l-54.317-1.315a2.334,2.334,0,0,1-2.278-2.334h0a2.334,2.334,0,0,1,2.334-2.335h54.152a2.335,2.335,0,0,1,2.317,2.044l.165,1.315A2.334,2.334,0,0,1,423.86,468.395Z",
  transform: "translate(-367.265 -462.411)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(48.041 18.599)"
}, /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M423.86,482.237l-54.317-1.315a2.335,2.335,0,0,1-2.278-2.334h0a2.334,2.334,0,0,1,2.334-2.334h54.152a2.335,2.335,0,0,1,2.317,2.043l.165,1.315A2.335,2.335,0,0,1,423.86,482.237Z",
  transform: "translate(-367.265 -476.253)"
})))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(168.706 70.85)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(51.635 22.566)"
}, /*#__PURE__*/React.createElement("path", {
  className: "l",
  d: "M462.84,380.7s-14.822.347-17.523-13.484l-10.359-2.16s-3.7,21.337,24.255,26.609Z",
  transform: "translate(-434.796 -365.054)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(23.738)"
}, /*#__PURE__*/React.createElement("path", {
  className: "m",
  d: "M524.915,357.963l-3.573,23.372-13.462-1.8L396.661,364.7a24.1,24.1,0,0,0,2.986-6.535,25.848,25.848,0,0,0,.879-4.178,24.3,24.3,0,0,0,.185-2.576,68.814,68.814,0,0,0-.255-7.466,53.7,53.7,0,0,0-.781-5.537,27.579,27.579,0,0,0-1.108-4.2l114.945,21.612Z",
  transform: "translate(-396.661 -334.207)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(27.534 9.735)"
}, /*#__PURE__*/React.createElement("path", {
  className: "n",
  d: "M511.6,367.9l-.96,6.278-108.72-16.62a24.3,24.3,0,0,0,.185-2.576,68.814,68.814,0,0,0-.255-7.466Z",
  transform: "translate(-401.849 -347.515)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(25.645)"
}, /*#__PURE__*/React.createElement("path", {
  className: "n",
  d: "M514.03,358.81l-113.656-20.4a27.579,27.579,0,0,0-1.108-4.2l114.945,21.612Z",
  transform: "translate(-399.267 -334.207)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(23.738 23.955)"
}, /*#__PURE__*/React.createElement("path", {
  className: "n",
  d: "M508.6,383.608l-.721,4.723-111.22-14.843a24.1,24.1,0,0,0,2.986-6.535Z",
  transform: "translate(-396.661 -366.953)"
})), /*#__PURE__*/React.createElement("path", {
  className: "l",
  d: "M387.949,364.7s-12.4-8.494-19.279-14.252c-2.617-2.193-4.433-3.989-4.459-4.769-.027-.835,2.2-2.176,5.344-3.653,7.515-3.522,20.3-7.816,20.3-7.816C398.448,353.443,387.949,364.7,387.949,364.7Z",
  transform: "translate(-364.211 -334.207)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 7.816)"
}, /*#__PURE__*/React.createElement("path", {
  className: "o",
  d: "M368.67,353.314c-2.617-2.193-4.433-3.989-4.459-4.769-.027-.835,2.2-2.176,5.344-3.653A10.391,10.391,0,0,1,368.67,353.314Z",
  transform: "translate(-364.211 -344.892)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(132.669 21.058)"
}, /*#__PURE__*/React.createElement("path", {
  className: "p",
  d: "M550.543,362.993l14.349,2.7-3.573,23.373-15.751-2.1Z",
  transform: "translate(-545.569 -362.993)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(148.42 23.756)"
}, /*#__PURE__*/React.createElement("path", {
  className: "h",
  d: "M570.673,366.681s15.7,2.013,15.774,5.853-1.248,17.623-3.453,18.285-15.894-.764-15.894-.764Z",
  transform: "translate(-567.1 -366.681)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(87.225 27.75)"
}, /*#__PURE__*/React.createElement("path", {
  className: "q",
  d: "M488.555,374.723a2.076,2.076,0,0,1,1.7-2.527c2.216-.639.7,4.444,6.206,3.9s3.651,1.775,5.424,3.463,9.54-2.2,12.326,4.475-2.111,11.566-11.735,11.9-5.824,5.652-13.972,2.7-4.541-15.932-2.249-17.969S488.555,374.723,488.555,374.723Z",
  transform: "translate(-483.447 -372.141)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(76.589 154.218)"
}, /*#__PURE__*/React.createElement("path", {
  className: "r",
  d: "M477.11,545.023s-.074,2.964-2.08,3.8-7.816,1.59-5.645,3.5c1.246,1.094,7.117.387,8.775.387s3.214.723,4.446-.387c1.356-1.221,0-7.3,0-7.3a6.619,6.619,0,0,1-2.717.712A5.28,5.28,0,0,1,477.11,545.023Z",
  transform: "translate(-468.907 -545.023)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(99.62 154.218)"
}, /*#__PURE__*/React.createElement("path", {
  className: "r",
  d: "M508.593,545.022s-.074,2.964-2.08,3.8-7.816,1.59-5.645,3.5c1.246,1.093,7.117.387,8.775.386s3.214.723,4.446-.387c1.356-1.22,0-7.3,0-7.3a6.619,6.619,0,0,1-2.717.712A5.274,5.274,0,0,1,508.593,545.022Z",
  transform: "translate(-500.39 -545.022)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(69.886 72.971)"
}, /*#__PURE__*/React.createElement("path", {
  className: "n",
  d: "M459.745,433.958s.143,13.66,1.241,37.761c.862,18.9.685,36.406,2.34,44.706.593,2.969,22.5,1.456,22.267-1.812l-5.187-58.375-.99-18.482Z",
  transform: "translate(-459.745 -433.958)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(68.522 77.537)"
}, /*#__PURE__*/React.createElement("path", {
  className: "s",
  d: "M495.465,446.552c-.182,1.51-8.721,1.326-19.173,0s-18.59-3.587-18.408-5.1,8.616-1.693,19.069-.37S495.647,445.042,495.465,446.552Z",
  transform: "translate(-457.88 -440.2)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(81.881 80.669)"
}, /*#__PURE__*/React.createElement("path", {
  className: "n",
  d: "M476.148,445.644l19.457,73.59c.934,3,19.392,2.6,18.815-.587l-15.1-69.6a2.22,2.22,0,0,0-1.541-1.661C493.6,446.177,475.737,442.679,476.148,445.644Z",
  transform: "translate(-476.141 -444.481)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(68.525 35.017)"
}, /*#__PURE__*/React.createElement("path", {
  className: "t",
  d: "M491.458,388.386s-1.985-6.676-12.563-6.3c-5.8.208-11.911-1.427-14.63,7.67a176.252,176.252,0,0,0-6.382,36.092s17.322-3.8,37.612,5.062C495.5,430.915,496.1,400.563,491.458,388.386Z",
  transform: "translate(-457.884 -382.075)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(71.127 34.523)"
}, /*#__PURE__*/React.createElement("path", {
  className: "t",
  d: "M499.949,387.222l-6.631,5.446s-26.361,7.783-30.01,4.083c-2.506-2.541-2.036-11.068-1.184-12.947a43.794,43.794,0,0,1,17.26-2.289,27.624,27.624,0,0,0,4.173.032C492.414,381.05,499.949,387.222,499.949,387.222Z",
  transform: "translate(-461.442 -381.4)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(80.812 91.249)"
}, /*#__PURE__*/React.createElement("path", {
  className: "u",
  d: "M486.867,492.287l-5.939-25.315a13.831,13.831,0,0,0-6.248-7.7l.187-.326a14.208,14.208,0,0,1,6.421,7.919l0,.015,5.941,25.323Z",
  transform: "translate(-474.68 -458.944)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(85.739 22.694)"
}, /*#__PURE__*/React.createElement("path", {
  className: "l",
  d: "M489.447,377.237a3.232,3.232,0,0,1-2.634-1.928l-1.448-3.364-.42-.976-2.472-5.74.429,5.949.258,3.571.073,1.018a1.623,1.623,0,0,1-1.34,1.713l-.014,0c-.44.715-1.048,2.169.767,2.746,2.132.679,5.582-1,6.82-2.989Z",
  transform: "translate(-481.415 -365.23)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(87.225 28.598)"
}, /*#__PURE__*/React.createElement("path", {
  className: "o",
  d: "M485.606,373.871a4.441,4.441,0,0,1-1.889,3.056l-.012-.01-.258-3.571C484.074,373.116,485.609,373.838,485.606,373.871Z",
  transform: "translate(-483.447 -373.3)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(79.674 14.948)"
}, /*#__PURE__*/React.createElement("ellipse", {
  className: "l",
  cx: 6.895,
  cy: 5.589,
  rx: 6.895,
  ry: 5.589,
  transform: "matrix(0.333, -0.943, 0.943, 0.333, 0, 13.004)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(70.074 79.643)"
}, /*#__PURE__*/React.createElement("path", {
  className: "n",
  d: "M487.63,445.687S466.766,441.7,460,443.582l3.244,4.808,12.059.682Z",
  transform: "translate(-460.002 -443.078)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(81.436 13.671)"
}, /*#__PURE__*/React.createElement("path", {
  className: "q",
  d: "M484.925,359.134c-.6,1.11-3.432,1.051-5.391.473-2.444-.722-3.337,2.394-3.8.949s-.295-5.531,2.5-7.073,9.24.194,9.645,2.4C488.472,359.123,485.443,358.185,484.925,359.134Z",
  transform: "translate(-475.533 -352.895)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(90.377 17.909)"
}, /*#__PURE__*/React.createElement("path", {
  className: "q",
  d: "M490.824,358.705s-1.734-.167-1.915.571-1.779,1.688-.881,2.51,1.053,1.182.77,1.969c-.2.549.337,2.1.291,3.326a3.966,3.966,0,0,1-.665,1.448,5.563,5.563,0,0,0,5.41-4.787C494.421,360.587,491.976,358.655,490.824,358.705Z",
  transform: "translate(-487.756 -358.689)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(90.082 23.595)"
}, /*#__PURE__*/React.createElement("path", {
  className: "l",
  d: "M489.336,368.985a1.373,1.373,0,0,1-1.91-.528,1.536,1.536,0,0,1,.98-1.828,1.373,1.373,0,0,1,1.91.528A1.536,1.536,0,0,1,489.336,368.985Z",
  transform: "translate(-487.353 -366.461)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(97.472 38.882)"
}, /*#__PURE__*/React.createElement("ellipse", {
  className: "s",
  cx: 6.65,
  cy: 1.732,
  rx: 6.65,
  ry: 1.732,
  transform: "matrix(0.845, -0.535, 0.535, 0.845, 0, 7.114)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(96.081 67.68)"
}, /*#__PURE__*/React.createElement("path", {
  className: "l",
  d: "M506.641,429.666s-3.5-3.207-6.268-2.924-6.084,2.735-4.332,2.924a18.314,18.314,0,0,0,4.056-.189s-4.885,1.037-4.148,2.075,4.977.094,4.977.094-5.715,1.7-4.7,2.453,5.347-.566,5.347-.566-5.255,1.792-4.056,2.641,4.333-1.509,5.07-.472,2.12,5.094,5.255,3.4Z",
  transform: "translate(-495.553 -426.725)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.441 2.426)"
}, /*#__PURE__*/React.createElement("path", {
  className: "v",
  d: "M501.726,430.47a.1.1,0,0,1-.036-.2c.057-.021,1.4-.516,2.151.013a.1.1,0,1,1-.119.167c-.657-.465-1.947.008-1.96.012A.1.1,0,0,1,501.726,430.47Z",
  transform: "translate(-501.624 -430.041)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(5.271 4.589)"
}, /*#__PURE__*/React.createElement("path", {
  className: "v",
  d: "M502.861,433.434a.1.1,0,0,1-.038-.2,3.606,3.606,0,0,1,2.533,0,.1.1,0,0,1-.083.188,3.453,3.453,0,0,0-2.375,0A.1.1,0,0,1,502.861,433.434Z",
  transform: "translate(-502.758 -432.999)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(5.916 6.439)"
}, /*#__PURE__*/React.createElement("path", {
  className: "v",
  d: "M503.743,436a.1.1,0,0,1-.037-.2c.067-.026,1.66-.614,2.407.018a.1.1,0,0,1-.132.157c-.656-.553-2.187.012-2.2.018A.1.1,0,0,1,503.743,436Z",
  transform: "translate(-503.64 -435.527)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(99.559 40.926)"
}, /*#__PURE__*/React.createElement("path", {
  className: "l",
  d: "M509.117,429.28c4.775-1.83,11.836-6.373,13.181-13.434,1.035-5.433-.927-11.625-5.83-18.4a33.292,33.292,0,0,0-7.23-7.266s-1.437-.336-4.576,1.562c-3.784,2.288-4.355,4.421-4.355,4.421,3.625,3.344,12.328,10.247,12.017,15.552a8.463,8.463,0,0,1-5.709,7.32Z",
  transform: "translate(-500.307 -390.153)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(52.927 3.965)"
}, /*#__PURE__*/React.createElement("path", {
  className: "l",
  d: "M445.189,340.413a1.736,1.736,0,0,1,2.236,1.786c.063,2.931-2.023,7.307-2.978,5.713a13.584,13.584,0,0,1-.049-2.936s-1.116,4.608-2.356,3.926-.21-4.823-.21-4.823-1.481,4.141-2.424,3.143-.174-3.767-.174-3.767-1.228,3.781-2.292,2.6.4-3.975.736-5.287c.314-1.238,1.241-1.234,2.508-.883a1.851,1.851,0,0,1,2.117.174c.26.209.89-.26,1.129-.236A4.5,4.5,0,0,1,445.189,340.413Z",
  transform: "translate(-436.561 -339.627)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(73.774 214.568)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.19 1.916)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M238.378,546.185s-5.053-5.151-3.315-8.085,4.673,6.3,4.673,6.3-1.522-10.922,1.63-11.111,0,11.111,0,11.111,1.168-2.635,2.309-2.8.816,2.235-1.222,4.581Z",
  transform: "translate(-234.7 -533.289)"
})), /*#__PURE__*/React.createElement("path", {
  className: "e",
  d: "M238.67,545.611a23.036,23.036,0,0,1-2.643-3.368c-1.614-2.554-2-4.582-1.143-6.026.319-.539.7-.787,1.14-.737,1.483.17,3.108,4.035,3.946,6.328-.088-.918-.181-2.127-.215-3.4-.1-3.609.3-5.985,1.186-7.065a1.7,1.7,0,0,1,1.239-.672,1.294,1.294,0,0,1,1.143.5c1.416,1.752.136,7.941-.567,10.837.525-.849,1.268-1.8,2.029-1.9a.736.736,0,0,1,.806.377c.459.842-.174,2.988-2.027,5.122l-.279-.242c1.822-2.1,2.322-4.08,1.982-4.7a.375.375,0,0,0-.43-.189c-.977.14-2.119,2.26-2.476,3.066l-.347-.125c.007-.025.7-2.514,1.161-5.24.606-3.564.558-5.9-.139-6.767a.931.931,0,0,0-.833-.362,1.33,1.33,0,0,0-.975.538c-1.988,2.427-.715,11.762-.7,11.855l-.359.082c-.659-2.075-2.7-7.5-4.184-7.669-.284-.031-.538.151-.781.559-1.878,3.169,3.676,8.89,3.732,8.947Z",
  transform: "translate(-234.44 -530.67)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(196.521 223.832)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.131 1.327)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M404.96,554.077s-3.5-3.568-2.295-5.6,3.236,4.364,3.236,4.364-1.053-7.563,1.129-7.694,0,7.694,0,7.694.809-1.824,1.6-1.938.564,1.547-.846,3.173Z",
  transform: "translate(-402.414 -545.147)"
})), /*#__PURE__*/React.createElement("path", {
  className: "e",
  d: "M405.163,553.68a15.916,15.916,0,0,1-1.83-2.332c-1.118-1.769-1.384-3.173-.792-4.173.221-.374.488-.546.789-.511.6.069,1.313,1.021,2.108,2.832.242.552.456,1.1.624,1.559-.192-1.98-.416-5.923.674-7.255a1.175,1.175,0,0,1,.858-.465.9.9,0,0,1,.792.345c.98,1.213.094,5.5-.393,7.5.363-.588.879-1.244,1.4-1.319a.51.51,0,0,1,.558.262c.318.583-.121,2.069-1.4,3.546l-.193-.167c1.261-1.453,1.607-2.825,1.372-3.257a.26.26,0,0,0-.3-.131c-.677.1-1.467,1.565-1.715,2.123l-.24-.086c0-.017.483-1.741.8-3.628.419-2.468.386-4.089-.1-4.685a.645.645,0,0,0-.576-.251.92.92,0,0,0-.675.372c-1.377,1.681-.5,8.144-.486,8.209l-.249.056c-.456-1.437-1.867-5.192-2.9-5.31-.2-.023-.373.1-.541.387-1.3,2.194,2.546,6.155,2.585,6.2Z",
  transform: "translate(-402.234 -543.333)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(34.031 217.788)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.131 1.327)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M182.838,545.815s-3.5-3.567-2.295-5.6,3.236,4.364,3.236,4.364-1.053-7.563,1.129-7.694,0,7.694,0,7.694.808-1.824,1.6-1.937.564,1.547-.847,3.172Z",
  transform: "translate(-180.291 -536.885)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "e",
  d: "M183.04,545.418a15.98,15.98,0,0,1-1.83-2.332c-1.118-1.768-1.384-3.173-.791-4.173.221-.374.487-.545.789-.511.6.069,1.312,1.022,2.107,2.832.242.551.456,1.1.625,1.558-.193-1.979-.416-5.923.673-7.254a1.179,1.179,0,0,1,.858-.466.9.9,0,0,1,.792.345c.98,1.213.094,5.5-.393,7.5.364-.588.879-1.244,1.4-1.319a.511.511,0,0,1,.559.262c.317.583-.121,2.069-1.4,3.547l-.194-.168c1.262-1.453,1.608-2.824,1.372-3.256a.258.258,0,0,0-.3-.131c-.677.1-1.467,1.565-1.715,2.123l-.241-.086c.005-.018.484-1.741.8-3.628.42-2.468.387-4.089-.1-4.686a.647.647,0,0,0-.577-.251.922.922,0,0,0-.675.373c-1.376,1.681-.495,8.144-.486,8.209l-.249.056c-.456-1.437-1.867-5.193-2.9-5.31-.194-.023-.372.1-.54.386-1.3,2.195,2.545,6.156,2.584,6.2Z",
  transform: "translate(-180.112 -535.071)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(147.591 225.714)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.181 1.857)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M339.159,560.943s-4.9-4.993-3.212-7.836,4.529,6.108,4.529,6.108-1.475-10.585,1.579-10.768,0,10.768,0,10.768,1.132-2.554,2.238-2.712.79,2.165-1.184,4.44Z",
  transform: "translate(-335.594 -548.445)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "e",
  d: "M339.443,560.387c-.231-.235-5.628-5.8-3.669-9.1.309-.523.683-.763,1.105-.715.844.1,1.836,1.43,2.949,3.964.339.772.639,1.543.873,2.181-.27-2.771-.583-8.29.942-10.153a1.647,1.647,0,0,1,1.2-.652,1.255,1.255,0,0,1,1.108.483c1.372,1.7.132,7.7-.549,10.5.508-.823,1.229-1.74,1.966-1.846a.715.715,0,0,1,.782.367c.444.816-.17,2.9-1.966,4.964l-.27-.236c1.765-2.033,2.249-3.953,1.92-4.557a.362.362,0,0,0-.416-.183c-.948.135-2.053,2.19-2.4,2.971l-.336-.121c.007-.024.676-2.437,1.125-5.078.587-3.454.541-5.722-.135-6.558a.906.906,0,0,0-.808-.35,1.288,1.288,0,0,0-.945.521c-1.926,2.352-.692,11.4-.68,11.489l-.348.079c-.639-2.011-2.613-7.268-4.055-7.432-.276-.03-.522.146-.756.541-1.819,3.07,3.563,8.615,3.617,8.671Z",
  transform: "translate(-335.347 -545.906)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(316.036 209.163)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.181 1.857)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M569.424,538.318s-4.9-4.992-3.212-7.835,4.528,6.108,4.528,6.108-1.474-10.585,1.58-10.768,0,10.768,0,10.768,1.132-2.554,2.238-2.712.789,2.166-1.185,4.44Z",
  transform: "translate(-565.859 -525.82)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "e",
  d: "M569.707,537.762c-.231-.236-5.628-5.8-3.669-9.1a1.158,1.158,0,0,1,1.105-.715c.845.1,1.837,1.43,2.949,3.964.339.772.639,1.543.873,2.181-.269-2.77-.582-8.29.943-10.153a1.649,1.649,0,0,1,1.2-.652,1.254,1.254,0,0,1,1.107.484c1.372,1.7.132,7.7-.549,10.5.508-.823,1.229-1.74,1.966-1.846a.717.717,0,0,1,.782.366c.444.816-.169,2.9-1.965,4.964l-.271-.235c1.766-2.034,2.25-3.954,1.921-4.558a.362.362,0,0,0-.416-.183c-.949.135-2.054,2.191-2.4,2.971l-.336-.121c.007-.024.676-2.437,1.125-5.078.587-3.454.541-5.722-.135-6.558a.91.91,0,0,0-.807-.35,1.285,1.285,0,0,0-.945.522c-1.927,2.353-.693,11.4-.68,11.489l-.348.079c-.639-2.011-2.613-7.267-4.055-7.432-.278-.032-.522.146-.756.541-1.819,3.07,3.563,8.615,3.617,8.671Z",
  transform: "translate(-565.611 -523.281)"
}))));
function SvgPictograma(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 375.16,
    height: 276.498,
    viewBox: "0 0 375.16 276.498",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictograma);
export default __webpack_public_path__ + "static/media/pictograma.06906f7ea0780364562da85fdf8f82d1.svg";
export { ForwardRef as ReactComponent };